import { render } from "./DashboardDepartures.vue?vue&type=template&id=15597909&ts=true"
import script from "./DashboardDepartures.vue?vue&type=script&lang=ts"
export * from "./DashboardDepartures.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__